import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router, RouterModule } from '@angular/router';
import { filter, map } from 'rxjs';
import { FeatherIconsComponent } from '../feather-icons/feather-icons.component';

@Component({
  selector: 'app-breadcrumb',
  imports: [CommonModule, RouterModule, FeatherIconsComponent],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})

export class BreadcrumbComponent {

  public breadcrumbs: {
    parentBreadcrumb?: string;
    parentLink?: string;
    childBreadcrumb?: string;
    enable?: boolean;
  } = {
      parentBreadcrumb: '',
      parentLink: '',
      childBreadcrumb: '',
      enable: false
    };
  public title: string = '';

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
      .subscribe(route => {
        const title = route.snapshot.data['title'];
        const child = route.snapshot.data['breadcrumb'];
        const parentRoute = route.parent;
        const parent = parentRoute?.snapshot.data['breadcrumb'];
        const isEnable = parentRoute?.snapshot.data['isEnable'];

        // Create correct absolute parent route path
        const segments = [];
        let tempRoute = route.parent;

        while (tempRoute) {
          if (tempRoute.routeConfig?.path) {
            segments.unshift(tempRoute.routeConfig.path);
          }
          tempRoute = tempRoute.parent;
        }

        const parentLink = '/' + segments.join('/');

        this.title = title;
        this.breadcrumbs = {
          parentBreadcrumb: parent?.charAt(0).toUpperCase() + parent?.slice(1),
          parentLink: parentLink,
          childBreadcrumb: child,
          enable: isEnable
        };
      });

  }

}
